import Utils from '../Services/Utils';
import SelectOptions from '../Services/SelectOptions';

class Trigger {
  constructor(item = {}) {
    let contactTypes = !Utils.isNull(item.contactTypes) ? item.contactTypes : null;
    if(Array.isArray(contactTypes)){
      contactTypes = contactTypes.map(item => !Utils.isNull(item.value) ? item.value : item);
    }
    else if (Utils.isObject(contactTypes)) {
      contactTypes = Utils.isObjectEmpty(contactTypes) ? null : contactTypes;
    }

    const emails = item.emails ? Utils.parseEmails(item.emails) : null;
    this.id = item.id || Utils.generateUUID();
    this.conditionType = item.conditionType || null;
    this.conditionValue = !Utils.isNull(item.conditionValue) ? item.conditionValue : null;
    this.templateID = item.templateID || null;
    this.triggerType = item.triggerType || null;
    this.workOrderRequired = item.workOrderRequired || false;
    this.emails = emails || [];
    this.contactTypes = contactTypes;
    this.pmsPlatform = item.pmsPlatform ? item.pmsPlatform : null;
    this.charge_code_id = item.charge_code_id ? item.charge_code_id : null;
    this.chargeCost = item.chargeCost || null;
    this.errors = {};
    this.trigger_upon_submission= item.trigger_upon_submission || false;
  }

  static parse(field, item, chargeCodes) {
    const conditionValueValue = item.condition_value || item.conditionValue;
    let condition = !Utils.isNull(conditionValueValue) ? (conditionValueValue.value || conditionValueValue) : null;
    if (Array.isArray(condition)) {
      condition = condition.map(item => !Utils.isNull(item.value) ? item.value : item);
    }
    const conditionValue = (field.options && field.options.length > 0) ? SelectOptions.getIndexValue(field.options,
      condition) : condition;
    const types = !Utils.isNull(item.contact_types) ? item.contact_types : item.contactTypes;
    let contactTypes = !Utils.isNull(types) ? types : null;
    if(Array.isArray(contactTypes)){
      contactTypes = contactTypes.map(item => !Utils.isNull(item.value) ? item.value : item);
    }
    else if (Utils.isObject(contactTypes)) {
      contactTypes = Utils.isObjectEmpty(contactTypes) ? null : contactTypes;
    }

    const emails = item.emails ? Utils.parseEmails(item.emails) : null;
    const templateID = !Utils.isNull(item.template_id) ? item.template_id : item.templateID;
    const charge_code_id = !Utils.isNull(item.charge_code_id) ? item.charge_code_id : null;
    const templateIDValue = !Utils.isNull(templateID) ? (templateID.value || templateID) : null;
    const conditionTypeValue = item.condition_type || item.conditionType;
    const type = !Utils.isNull(conditionTypeValue) ? (conditionTypeValue.value || conditionTypeValue) : null;
    const triggerTypeValue = item.trigger_type || item.triggerType;
    const triggerType = !Utils.isNull(triggerTypeValue) ? (triggerTypeValue.value || triggerTypeValue) : null;
    const workOrderRequired = !Utils.isNull(item.work_order_required) ? item.work_order_required : item.workOrderRequired;
    const trigger_upon_submission = item.trigger_upon_submission || false;

    let chargeCost = (charge_code_id && chargeCodes) ? chargeCodes.find(cd => cd.id === charge_code_id) : null;
    let pms_platform = null;
    if (!Utils.isNull(item.pms_platform)) {
      pms_platform = item.pms_platform;
    }
    else {
      pms_platform = (!Utils.isNull(chargeCost) ? chargeCost.pms_platform?.id : null);
    }
    chargeCost = !Utils.isNull(chargeCost) ? new Intl.NumberFormat(
      'en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(chargeCost.default_amount / 100) : null;

    return new Trigger({
        id: item.id || null,
        conditionType: type ? this._parseConditionType(type) : null,
        conditionValue: !Utils.isNull(conditionValue) ? conditionValue : null,
        templateID: templateIDValue ? { value: templateIDValue, label: null } : null,
        triggerType: triggerType || null,
        workOrderRequired: workOrderRequired || false,
        emails: emails || [],
        contactTypes: contactTypes,
        pmsPlatform: pms_platform,
        charge_code_id: charge_code_id,
        chargeCost: chargeCost,
        trigger_upon_submission:trigger_upon_submission
      },
    );
  }

  serialize() {
    const conditionIsNotNull = !Utils.isNull(this.conditionValue);
    const conditionIsArray = Array.isArray(this.conditionValue);
    const conditionIsObject = Utils.isObject(this.conditionValue);
    let conditionValue = null;
    if (conditionIsNotNull && conditionIsArray) {
      conditionValue = this.conditionValue.map(item => item.value)
    }
    else {
      conditionValue = (conditionIsObject ? this.conditionValue.value : this.conditionValue)
    };
    let triggerData = {
      id: this.id,
      condition_type: this.conditionType.value,
      condition_value: conditionValue,
      trigger_type: this.triggerType,
    };

    if (this.triggerType === '0') {
      triggerData = {
        ...triggerData,
        template_id: this.templateID.value,
      };
    }

    if (this.triggerType === '1') {
      let contactTypes = !Utils.isNull(this.contactTypes) ? this.contactTypes : null;
      if (Array.isArray(contactTypes)) {
        contactTypes = contactTypes.map(item => !Utils.isNull(item.value) ? item.value : item);
      }
      else if (Utils.isObject(contactTypes)) {
        contactTypes = Utils.isObjectEmpty(contactTypes) ? null : contactTypes;
      }

      triggerData = {
        ...triggerData,
        emails: Utils.parseEmails(this.emails),
        contact_types: contactTypes,
        trigger_upon_submission: this.trigger_upon_submission
      };
    }

    if (this.triggerType === '2') {
      triggerData = {
        ...triggerData,
        work_order_required: this.workOrderRequired,
      };
    }

    if (this.triggerType === '3') {
      triggerData = {
        ...triggerData,
        charge_code: this.chargeCode,
        charge_code_id: this.charge_code_id
      }
    }

    return triggerData;
  }

  static _parseConditionType(val) {
    let value = Utils.isObject(val) ? val.value : val;
    if(value == 'Empty'){
      value = 'Is Empty'
    }
    else if(value == 'Not Empty'){
      value = 'Is Not Empty'
    }
    return {
      label: value.substr(0, 1).toUpperCase() + value.substr(1).toLowerCase(),
      value: value,
    };
  }

}

export default Trigger;